export { default } from './useSearchCorpUsers';
